// The domain MediCase's tenants live under: <slug>.medi-case.co.uk. Every
// link the app builds to a tenant (class invite links, the QR code, admin
// hints) comes from here, so a domain move is one line. auxtechna.co.uk is
// the company's own domain and its subdomains belong to other products, so
// a tenant link must never be built on it.
export const PUBLIC_DOMAIN = process.env.REACT_APP_PUBLIC_DOMAIN || 'medi-case.co.uk';

export const MARKETING_URL = `https://www.${PUBLIC_DOMAIN}`;

export const tenantUrl = (slug) => `https://${slug}.${PUBLIC_DOMAIN}`;
